import Scrollbars from './Scrollbars';
export default Scrollbars;
export { Scrollbars };



// WEBPACK FOOTER //
// ./src/widget/ScrollBar/index.js